import React from 'react';
import {
  Box,
  Typography,
  Card,
  CardContent,
  LinearProgress,
} from '@mui/material';
import { TrendingUp, TrendingDown } from '@mui/icons-material';
import { DESIGN_TOKENS } from '../../../design-system/tokens/colors';

export const PriceReport: React.FC = () => {
  // Mock data - in a real app, this would come from an API
  const priceData = [
    { animal: 'Boi Gordo', currentPrice: 'R$ 280/arroba', change: '+5.2%', trend: 'up' },
    { animal: 'Vaca Gorda', currentPrice: 'R$ 260/arroba', change: '+3.1%', trend: 'up' },
    { animal: 'Bezerro', currentPrice: 'R$ 1.800/cabeça', change: '-2.5%', trend: 'down' },
    { animal: 'Bezerra', currentPrice: 'R$ 1.600/cabeça', change: '+1.8%', trend: 'up' },
  ];

  const monthlyTrend = [
    { month: 'Janeiro', value: 275 },
    { month: 'Fevereiro', value: 268 },
    { month: 'Março', value: 272 },
    { month: 'Abril', value: 280 },
    { month: 'Maio', value: 285 },
    { month: 'Junho', value: 280 },
  ];

  const maxValue = Math.max(...monthlyTrend.map(m => m.value));

  return (
    <Box sx={{ p: 3 }}>
      <Typography variant="h4" sx={{ mb: 3, fontWeight: 700, color: DESIGN_TOKENS.colors.primary[700] }}>
        Relatório de Preços
      </Typography>
      <Typography variant="body1" sx={{ mb: 3, color: DESIGN_TOKENS.colors.text.secondary }}>
        Preços atualizados e tendências do mercado
      </Typography>

      {/* Current Prices */}
      <Card sx={{ mb: 3 }}>
        <CardContent>
          <Typography variant="h6" sx={{ mb: 2, fontWeight: 600, color: DESIGN_TOKENS.colors.primary[700] }}>
            Preços Atuais
          </Typography>
          {priceData.map((item, index) => (
            <Box key={index} sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', py: 2, borderBottom: index < priceData.length - 1 ? `1px solid ${DESIGN_TOKENS.colors.neutral[200]}` : 'none' }}>
              <Box>
                <Typography variant="body1" sx={{ fontWeight: 600 }}>
                  {item.animal}
                </Typography>
                <Typography variant="h6" sx={{ color: DESIGN_TOKENS.colors.primary[700], fontWeight: 700 }}>
                  {item.currentPrice}
                </Typography>
              </Box>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                {item.trend === 'up' ? (
                  <TrendingUp sx={{ color: DESIGN_TOKENS.colors.organization.farm }} />
                ) : (
                  <TrendingDown sx={{ color: DESIGN_TOKENS.colors.status.error[500] }} />
                )}
                <Typography
                  variant="body2"
                  sx={{
                    color: item.trend === 'up' ? DESIGN_TOKENS.colors.organization.farm : DESIGN_TOKENS.colors.status.error[500],
                    fontWeight: 600,
                  }}
                >
                  {item.change}
                </Typography>
              </Box>
            </Box>
          ))}
        </CardContent>
      </Card>

      {/* Monthly Trend */}
      <Card>
        <CardContent>
          <Typography variant="h6" sx={{ mb: 2, fontWeight: 600, color: DESIGN_TOKENS.colors.primary[700] }}>
            Tendência Mensal (Boi Gordo - R$/arroba)
          </Typography>
          {monthlyTrend.map((month, index) => (
            <Box key={index} sx={{ mb: 2 }}>
              <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 1 }}>
                <Typography variant="body2">{month.month}</Typography>
                <Typography variant="body2" sx={{ fontWeight: 600 }}>
                  R$ {month.value}
                </Typography>
              </Box>
              <LinearProgress
                variant="determinate"
                value={(month.value / maxValue) * 100}
                sx={{
                  height: 8,
                  borderRadius: 4,
                  backgroundColor: DESIGN_TOKENS.colors.neutral[200],
                  '& .MuiLinearProgress-bar': {
                    backgroundColor: DESIGN_TOKENS.colors.organization.farm,
                  },
                }}
              />
            </Box>
          ))}
        </CardContent>
      </Card>
    </Box>
  );
};